import { all, takeEvery, takeLeading, takeLatest, put, call, select } from 'redux-saga/effects'
import { notification } from 'antd'
import { history } from 'index'
import i18n from 'i18next'
import { getConfig } from 'env'
import { getSearchParams } from 'utils'

import store from 'store'

// import * as firebase from 'services/firebase'
import * as jwt from 'services/jwt'
import * as landing from 'services/landing'
import actions from './actions'

const mapAuthProviders = {
  // firebase: {
  //   login: firebase.login,
  //   register: firebase.register,
  //   currentAccount: firebase.currentAccount,
  //   logout: firebase.logout,
  // },
  jwt: {
    login: jwt.login,
    loginByOTP: jwt.loginByOTP,
    loginByKey: jwt.loginByKey,
    register: jwt.register,
    currentAccount: jwt.currentAccount,
    logout: jwt.logout,
  },
  landing: {
    login: landing.login,
    loginByOTP: landing.loginByOTP,
    loginByKey: landing.loginByKey,
    register: landing.register,
    currentAccount: landing.currentAccount,
    logout: landing.logout,
  },
}

export function* LOGIN_BY_OTP({ payload }) {
  const { email, loginCode } = payload
  // yield console.log(email, loginCode)

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider: autProviderName } = yield select((state) => state.settings)
  const success = yield call(mapAuthProviders[autProviderName].loginByOTP, email, loginCode)
  if (success) {
    yield INNER_LOAD_CURRENT_ACCOUNT()

    if (window.location.pathname !== '/provisioning/deleteDomain') {
      const provisioning = yield store.get('app.user.provisioning')

      if (provisioning === true) {
        console.log(' --- push (/provisioning/settings)')
        yield history.push('/provisioning/settings')
      } else {
        const onLoadAccount = () => {
          const params = getSearchParams()
          const defaultPage = getConfig('defaultPage') || '/'
          const target = params.path != null ? window.decodeURIComponent(params.path) : defaultPage
          history.push(target)
        }

        yield onLoadAccount()
      }
    }
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })

  if (!success) {
    yield history.push('/auth/login')
  }
}

export function* LOGIN({ payload }) {
  const { email, password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider: autProviderName } = yield select((state) => state.settings)
  const success = yield call(mapAuthProviders[autProviderName].login, email, password)
  if (success) {
    yield INNER_LOAD_CURRENT_ACCOUNT()

    if (window.location.pathname !== '/provisioning/deleteDomain') {
      const provisioning = yield store.get('app.user.provisioning')

      if (provisioning === true) {
        console.log(' --- push (/provisioning/settings)')
        yield history.push('/provisioning/settings')
      } else {
        const onLoadAccount = () => {
          const params = getSearchParams()
          const defaultPage = getConfig('defaultPage') || '/'
          const target = params.path != null ? window.decodeURIComponent(params.path) : defaultPage
          history.push(target)
        }

        yield onLoadAccount()
      }
    }
    // notification.success({
    //   message: 'Logged In',
    //   description: 'You have successfully logged in!',
    // })
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })

  if (!success) {
    // notification.warning({
    //   message: 'Login error',
    //   description: 'LoginByKey failed.',
    // })
    yield history.push('/auth/login')
  }
}

export function* LOGIN_BY_KEY({ payload }) {
  const { key } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider: autProviderName } = yield select((state) => state.settings)
  const result = yield call(mapAuthProviders[autProviderName].loginByKey, key)
  if (result === 'success') {
    yield INNER_LOAD_CURRENT_ACCOUNT()

    if (window.location.pathname !== '/provisioning/deleteDomain') {
      const provisioning = yield store.get('app.user.provisioning')

      if (provisioning === true) {
        console.log(' --- push (/provisioning/settings)')
        yield history.push('/provisioning/settings')
      } else {
        const onLoadAccount = () => {
          const params = getSearchParams()
          const defaultPage = getConfig('defaultPage') || '/'
          const target = params.path != null ? window.decodeURIComponent(params.path) : defaultPage
          history.push(target)
        }

        yield onLoadAccount()
      }
    }
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })

  if (result !== 'success') {
    // notification.warning({
    //   message: 'Login error',
    //   description: 'LoginByKey failed.',
    // })
    yield history.push('/auth/login')
  }
}

export function* OAUTHLOGIN({ payload }) {
  // yield put({
  //   type: 'user/LOAD_CURRENT_ACCOUNT',
  // })
  // yield history.replace('/plain/waiting')
  yield put({
    type: 'user/LOAD_CURRENT_ACCOUNT',
  })

  const provisioning = yield store.get('app.user.provisioning')

  if (provisioning !== true) {
    const defaultPage = getConfig('defaultPage') || '/'
    const target = payload && payload.target ? payload.target : defaultPage
    history.push(target)
  }
  // notification.success({
  //   message: 'Logged In',
  //   description: 'You have successfully logged in!',
  // })
}

export function* REGISTER({ payload }) {
  const { email, password, name } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider } = yield select((state) => state.settings)
  const success = yield call(mapAuthProviders[authProvider].register, email, password, name)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })

    const provisioning = yield store.get('app.user.provisioning')

    if (provisioning === true) {
      console.log(' --- push (/provisioning/settings)')
      yield history.push('/provisioning/settings')
    } else {
      yield history.push('/')
    }

    notification.success({
      message: 'Succesful Registered',
      description: 'You have successfully registered!',
    })
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

function* INNER_LOAD_CURRENT_ACCOUNT() {
  const { authProvider } = yield select((state) => state.settings)
  const response = yield call(mapAuthProviders[authProvider].currentAccount)
  if (response) {
    const { id, email, name, avatar, role, serverType, workspace, provisioning } = response
    yield put({
      type: 'user/SET_STATE',
      payload: {
        id,
        name,
        email,
        avatar,
        role,
        authorized: true,
        serverType,
        workspace,
        provisioning,
      },
    })

    //   const onLoadAccount = () => {
    //     const params = getSearchParams()
    //     const defaultPage = getConfig('defaultPage') || '/'
    //     const target = params.path != null ? window.decodeURIComponent(params.path) : defaultPage
    //     history.push(target);
    //   };

    //   yield onLoadAccount();
    // }
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  yield INNER_LOAD_CURRENT_ACCOUNT()

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* UPDATE_ALLOWED_DOMAIN({ payload }) {
  const { id } = payload

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  try {
    const workspaceId = yield store.get('app.user.workspace_id')
    if (workspaceId == null) {
      console.error('workspace_id not found in localStorage')
      yield put({
        type: 'user/SET_STATE',
        payload: {
          loading: false,
        },
      })
      return
    }

    const workspaceInfo = yield call(landing.getWorkspaceInfo, workspaceId)

    if (workspaceInfo) {
      const { allowedDomain } = workspaceInfo
      const currentUser = yield select((state) => state.user)

      yield put({
        type: 'user/SET_STATE',
        payload: {
          workspace: {
            domainInfo: {
              ...currentUser.workspace.domainInfo,
              domain: allowedDomain,
              info: allowedDomain,
              id,
            },
            allowedDomain,
          },
        },
      })

      notification.success({
        message: 'Success',
        description: i18n.t('appConfig.domain.result.updateSuccess'),
      })

      //   console.log('allowedDomain updated:', allowedDomain)
    }
  } catch (error) {
    console.error('Error updating allowedDomain:', error)
    notification.error({
      message: 'Error',
      description: 'Failed to update domain information',
    })
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT() {
  const { authProvider } = yield select((state) => state.settings)
  yield call(mapAuthProviders[authProvider].logout)
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false,
    },
  })
  // yield history.push('/');
}

export default function* rootSaga() {
  yield all([
    takeLeading(actions.LOGIN_BY_OTP, LOGIN_BY_OTP),
    takeLeading(actions.LOGIN, LOGIN),
    takeLeading(actions.LOGIN_BY_KEY, LOGIN_BY_KEY),
    takeEvery(actions.OAUTHLOGIN, OAUTHLOGIN),
    takeEvery(actions.REGISTER, REGISTER),
    takeLatest(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeLatest(actions.UPDATE_ALLOWED_DOMAIN, UPDATE_ALLOWED_DOMAIN),
    takeLeading(actions.LOGOUT, LOGOUT),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
